<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">{{ $t('menuOrganization.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch" :clearable="false"
                              :options="organizationBranchOptions">
                        <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">{{ $t('button.employee') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">{{ $t('menuOrganization.status') }}</label>
                    <v-select class="" v-model="leaveStatusModel" :clearable="false" :options="leaveStatusOptions">
                        <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">{{ $t('menuEvent.time') }}</label>
                    <div class="w-full">
                        <date-range-picker
                            ref="picker" class="w-full"
                            :locale-data="{format: 'dd/mm/yyyy' }"
                            :opens="'left'"
                            @update="dateRangePicker"
                            v-model="dateRange">
                        </date-range-picker>
                    </div>
                </div>
                <div class="vx-col w-full lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-4">
                    <label class="vs-input--label">Tìm kiếm</label>
                    <vs-input class="w-full"
                              v-model="searchQuery"
                              @input="updateSearchQuery" :placeholder="$t('button.search')"/>
                </div>
                <div class="vx-col w-full lg:w-3/4 w-full mt-4 lg:mt-8">
                    <div class="flex flex-wrap">
                        <vs-button
                            class="mr-2 mt-2"
                            @click="loadLeave"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-search">
                            Tìm kiếm
                        </vs-button>
                        <vs-button
                            v-if="isPermission"
                            @click="addLeave"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-plus"
                            class="mt-2 mr-2">
                            {{ $t('updateInout.create') }}
                        </vs-button>
                        <vs-button iconPack="feather" icon="icon-download" @click="generateReport" class="mt-2">
                            {{ $t('updateInout.export') }}
                        </vs-button>
                    </div>
                </div>
            </div>
            <div class="mt-4 vx-row">
                <div class="vx-col md:w-1/2 button-create w-full flex" style="display: inline-block">

                </div>
                <div class="vx-col md:w-1/4 button-create w-full">

                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="leaveData"
                         :animateRows="true"
                         :pagination="true"
                         :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <div class="vx-row mt-8">
                <div style="min-width:200px" class="vx-col md:w-1/2 w-full">
                    <span class="content-page font-bold">Hiển thị: </span>
                    <span class="text-page">
                        {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{ totalElements }}
                    </span>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                    <vs-pagination
                        :total="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import moment from 'moment'
// import utils from "../../../components/utils";
import Pagination from "../../../ui-elements/Pagination.vue"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constRouter} from "../../../../store/constant";

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
        Datepicker,
        flatPickr,
        DateRangePicker,
        Pagination,
        CellRendererStatus
    },
    data() {
        return {
            listEmployeeIds: [],
            //isInitComplete: false,
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuOrganization.employeeCode'),
                    field: 'employeeCode',
                    width: 150
                },
                {
                    headerName: this.$t('menuOrganization.employeeName'),
                    field: 'fullName',
                    width: 180
                },
                {
                    headerName: this.$t('menuOrganization.displayLeaveDate'),
                    field: 'displayLeaveDate',
                    width: 180,
                },
                {
                    headerName: this.$t('menuOrganization.displayLeaveTime'),
                    field: 'displayLeaveTime',
                    width: 120,
                },
                {
                    headerName: this.$t('menuOrganization.status'),
                    field: 'displayStatus',
                    cellRendererFramework: 'CellRendererStatus',
                    width: 120,
                },
                {
                    headerName: this.$t('textErr.reason'),
                    field: 'reason',
                    width: 200,
                },
                {
                    headerName: this.$t('menuOrganization.approveEmployeeFullName'),
                    field: 'approveEmployeeFullName',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 170,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
                CellRendererStatus
            },
            dateRange: {
                startDate: new Date(),
                endDate: (() => {
                    let date = new Date();
                    date.setDate(date.getDate() + 6);
                    date.setHours(0, 0, 0);
                    return date
                })()
            },
            leaveData: [],
            employeeOptions: [
                {value: null, label: this.$t('menuOrganization.all')}
            ],
            leaveStatusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đã duyệt'},
                {value: 2, label: 'Từ chối'},
                {value: 3, label: 'Hủy bỏ'}
            ],
            organizationBranchOptions: [],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            selectedStatus: null,
            status: null,
            fromDate: moment().format("YYYY/MM/DD"),
            toDate: moment().format("YYYY/MM/DD"),
            countElementPage: 0,
            totalElements: 0,
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateLeave'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_LEAVE', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj.value
                this.loadEmployee()
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
        leaveStatusModel: {
            get() {
                return {
                    label: this.leaveStatusOptions.find(x => x.value == this.status).label,
                    value: this.status
                }
            },
            set(obj) {
                this.status = obj.value;
            }
        },
    },
    methods: {
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value == id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuOrganization.null');
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value == id);
            return (employee && employee.label) || this.$t('menuOrganization.null');
        },
        loadEmployee() {
            if (!this.selectedOrganizationBranchValue) return;

            this.$vs.loading();
            this.$crm.post('/employee/find-by-organization-branch/' + this.selectedOrganizationBranchValue).then((response) => {
                this.employeeData = response.data;
                this.listEmployeeIds = response.data.map(el => el.employeeId);
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + " " + item.fullName,
                        ...item
                    }
                });
                this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                this.$vs.loading.close();
                this.loadLeave()

                /*if (!this.isInitComplete) {
                  this.loadLeave()
                  this.isInitComplete = true
                }*/
            }).catch((err) => {
                this.$vs.loading.close();
                //this.isInitComplete = true;
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        addLeave() {
            this.$router.push(`/user/assign-leave?branch_id=${this.selectedOrganizationBranchValue}`).catch(() => {
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];

        },
        isPermission() {
            return isRouter(this, constRouter.leave_add);
        },
        loadLeave() {
            if (!this.selectedOrganizationBranchValue) return;
            let condition = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployeeValue,
                status: this.status,
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 0})
            }
            if (!this.selectedEmployeeValue) condition.employeeIds = this.listEmployeeIds;
            this.$vs.loading();
            this.$crm.post('/leave/find', condition).then((response) => {
                this.leaveData = response.data.map(item => {
                    item.displayLeaveDate = moment(item.fromDate).format("DD/MM") + " - " + moment(item.toDate).format("DD/MM");
                    item.displayLeaveType = item.leaveType == 0 ? 'Nghỉ phép' : 'Nghỉ thường';
                    item.displayLeaveTime = item.duration == 0 ? 'Cả ngày' : 'Cố định'
                    item.displayStatus = item.status == 0 ? 'Chờ' : item.status == 1 ? 'Đã duyệt' : item.status == 2 ? 'Từ chối' : 'Hủy';
                    if (item.status == 0) item.approveEmployeeFullName = null;
                    let employee = this.employeeOptions.find(employee => employee.employeeId == item.employeeId);
                    let mergeData = {...item, ...employee}
                    mergeData.id = item.id;
                    return mergeData;
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                this.countElementPage = this.currentPage * this.paginationPageSize;
                this.totalElements = this.leaveData.length
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        generateReport() {
            this.$vs.loading()
            let data = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployeeValue,
                status: this.status,
                fromDate: moment(this.dateRange.startDate).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
                toDate: moment(this.dateRange.endDate).set({hour: 23, minute: 59, second: 59, millisecond: 0})
            }

            this.$crm.post('/leave/export', data).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>
.md\:w-1\/5 {
    width: 23.5% !important;
}

</style>
<style lang="scss">
.time-button {
    @media screen and (max-width: 1350px) {
        margin-top: 0.5rem;
    }
    @media screen and (max-width: 1200px) {
        margin-top: 0;
    }
}
</style>
